/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingAnalyticsConfig } from '../../config/loading.config';
export interface ILoadingAnalyticsPluginMethods extends IPluginMethodMap {
  getLoadingAnalyticsSync(args?: any): any;
}

export class LoadingAnalyticsPlugin implements IAgentPlugin {
  readonly methods: ILoadingAnalyticsPluginMethods;

  constructor() {
    this.methods = {
      getLoadingAnalyticsSync: this.getLoadingAnalyticsSync.bind(this),
    };
  }

  getLoadingAnalyticsSync(args?: any) {
    return {
      loading: loadingAnalyticsConfig,
    };
  }
}
